import React from 'react';
import { outlineTexts } from '../contexts/LangHO2';
import outlineImg from '../assets/images/halcyon/outline.png';

function ProductHOOutline2({ lang = 'ko', isMobile = false }) {
  return (
    <div
      style={{
        width: '100vw',
        maxWidth: '100vw',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: isMobile ? '0 10px' : '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      {/* 제목 */}
      <span style={{
        fontSize: isMobile ? '1.7rem' : '2rem',
        fontWeight: 700,
        color: '#fff',
        marginBottom: isMobile ? 20 : 30,
        paddingLeft: isMobile ? 20 : 40,
        paddingRight: isMobile ? 20 : 40,
        paddingTop: isMobile ? 20 : 28,
        display: 'block',
        letterSpacing: '-0.02em',
        textAlign: 'center',
        width: '100%'
      }}>
        {outlineTexts.title[lang]}
      </span>
      
      {/* 콘텐츠 영역 - 이미지만 표시 */}
      <Imagesection isMobile={isMobile} />
      
      {/* 컨테이너 섹션 */}
      <ContainerSection lang={lang} isMobile={isMobile} />
    </div>
  );
}

function Imagesection({ isMobile = false }) {
  return (
    <div style={{
      width: '100%',
      padding: isMobile ? '0 20px 10px 20px' : '0 40px 10px 40px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <img
        src={outlineImg}
        alt="Security Strategy Outline"
        style={{
          maxWidth: isMobile ? '350px' : '800px',
          width: '100%',
          height: 'auto',
          objectFit: 'contain'
        }}
      />
    </div>
  );
}

function ContainerSection({ lang = 'ko', isMobile = false }) {
  return (
    <div style={{
      width: '100%',
      padding: isMobile ? '0 20px 40px 20px' : '0 40px 40px 40px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      {/* 컨테이너 타이틀 */}
      <div style={{
        width: isMobile ? '100%' : 'calc(80% + 90px)',
        fontSize: isMobile ? '1.5rem' : '1.8rem',
        fontWeight: 700,
        color: '#fff',
        background: '#0066CC',
        borderRadius: 50,
        padding: isMobile ? '15px 20px' : '20px 30px',
        marginBottom: isMobile ? 10 : 15,
        textAlign: 'center'
      }}>
        {outlineTexts.container.title[lang]}
      </div>
      
      {/* 컨테이너 그룹 */}
      <div style={{
        width: '100%',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? 20 : 30,
        justifyContent: 'center',
        alignItems: 'center'
      }}>
      {/* 컨테이너 1 */}
      <div style={{
        width: isMobile ? '100%' : '20%',
        height: isMobile ? 'auto' : 320,
        background: '#203864',
        borderRadius: 12,
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}>
        <div style={{
          color: '#00FF00',
          fontSize: isMobile ? '1rem' : '1.2rem',
          fontWeight: 600,
          textAlign: 'center',
          marginBottom: 15
        }}>
          {outlineTexts.container.encryptkey.title[lang]}
        </div>
        <div style={{
          color: '#fff',
          fontSize: isMobile ? '0.8rem' : '0.9rem',
          textAlign: 'left',
          lineHeight: 1.4,
          width: '100%'
        }}>
          <div style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.encryptkey.text.t1[lang]}</span>
          </div>
          <div style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.encryptkey.text.t2[lang]}</span>
          </div>
          <div style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.encryptkey.text.t3[lang]}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.encryptkey.text.t4[lang]}</span>
          </div>
        </div>
      </div>

      {/* 컨테이너 2 */}
      <div style={{
        width: isMobile ? '100%' : '20%',
        height: isMobile ? 'auto' : 320,
        background: '#203864',
        borderRadius: 12,
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}>
        <div style={{
          color: '#00FF00',
          fontSize: isMobile ? '1rem' : '1.2rem',
          fontWeight: 600,
          textAlign: 'center',
          marginBottom: 15
        }}>
          {outlineTexts.container.engine.title[lang]}
        </div>
        <div style={{
          color: '#fff',
          fontSize: isMobile ? '0.8rem' : '0.9rem',
          textAlign: 'left',
          lineHeight: 1.4,
          width: '100%'
        }}>
          <div style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.engine.text.t1[lang]}</span>
          </div>
          <div style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.engine.text.t2[lang]}</span>
          </div>
          <div style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.engine.text.t3[lang]}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.engine.text.t4[lang]}</span>
          </div>
        </div>
      </div>

      {/* 컨테이너 3 */}
      <div style={{
        width: isMobile ? '100%' : '20%',
        height: isMobile ? 'auto' : 320,
        background: '#203864',
        borderRadius: 12,
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}>
        <div style={{
          color: '#00FF00',
          fontSize: isMobile ? '1rem' : '1.2rem',
          fontWeight: 600,
          textAlign: 'center',
          marginBottom: 15
        }}>
          {outlineTexts.container.independence.title[lang]}
        </div>
        <div style={{
          color: '#fff',
          fontSize: isMobile ? '0.8rem' : '0.9rem',
          textAlign: 'left',
          lineHeight: 1.4,
          width: '100%'
        }}>
          <div style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.independence.text.t1[lang]}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.independence.text.t2[lang]}</span>
          </div>
        </div>
      </div>

      {/* 컨테이너 4 */}
      <div style={{
        width: isMobile ? '100%' : '20%',
        height: isMobile ? 'auto' : 320,
        background: '#203864',
        borderRadius: 12,
        padding: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start'
      }}>
        <div style={{
          color: '#00FF00',
          fontSize: isMobile ? '1rem' : '1.2rem',
          fontWeight: 600,
          textAlign: 'center',
          marginBottom: 15
        }}>
          {outlineTexts.container.environment.title[lang]}
        </div>
        <div style={{
          color: '#fff',
          fontSize: isMobile ? '0.8rem' : '0.9rem',
          textAlign: 'left',
          lineHeight: 1.4,
          width: '100%'
        }}>
          <div style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.environment.text.t1[lang]}</span>
          </div>
          <div style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.environment.text.t2[lang]}</span>
          </div>
          <div style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.environment.text.t3[lang]}</span>
          </div>
          <div style={{ marginBottom: 8, display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.environment.text.t4[lang]}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <span style={{ color: '#0070C0', marginRight: 8, fontSize: '1.2em' }}>●</span>
            <span>{outlineTexts.container.environment.text.t5[lang]}</span>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}



export default ProductHOOutline2;